
export const cashConfig = `<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （1）福运天地活动时间为 2024 年10 月 04 日至 2025 年10 月 04 日；活动范围为所有进入本游戏的用户；本次活动名额仅限前 100000 名用户。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （2）请您理解并同意产品内分红及现金发放数量随机。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （3）福运天地展示多个提现比例，使用每个提现比例有自己的使用要求，用户达到后方可按对应提现比例进行提现。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （4）单个用户总提现次数不限，单日最高可提 10 次。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    您可满足对应提现比例要求后进行提现，具体规则如下：
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （6）【零钱提现】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    每日最多可提现3次，单笔最低0.1元，最高10000元，达到上限后，当日不可再提现，需要到次日后才可继续提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    r.1%提现：通过第1关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于1%即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    s.1.5%提现：通过第3关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于1.5%即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    t.50%提现：通过第5关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于50%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    u.100%提现：通过第10关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于100%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    v.200%提现：通过第15关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于200%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    w.300%提现：通过第20关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于300%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    x.400%提现：通过第25关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于400%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    y.500%提现：通过第30关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于500%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    z.600%提现：通过第35关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于600%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    aa.700%提现：通过第40关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于700%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    ab.800%提现：通过第45关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于800%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    ac.900%提现：通过第50关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于900%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    ad.1000%提现：通过第60关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于1000%，审核通过后点亮全部成就即可提现；  
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    ae.1100%提现：通过第70关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于1100%，审核通过后点亮全部成就即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    af.1200%提现：通过第80关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于1200%，审核通过后点亮全部成就即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    ag.1300%提现：通过第90关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于1300%，审核通过后点亮全部成就即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    ah.1500%提现：通过第100关且计算账号零钱提现比例（根据完成关卡数、在线时长、观看广告次数、是否是幸运用户用户计算）大于1500%，审核通过后点亮全部成就即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （6）【红包提现】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    用户通过玩游戏、观看视频获得游戏现金，用户可提现金额=所选提现汇率*当前现金账户余额，可提现金额达到 0.1 元方可进行提现，最大提现额度限制为 1000元，每天 10 次提现机会，无时间限制或注册时长限制。当用户累计提现的金额+当前提现的余额<累计看广告为平台产生的收益即可提现，当不满足时，会
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    h.10000元红包=1元人民币：通过第1关即可提现； 
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    i.10000元红包=1.2元人民币：通过第4关即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    j.10000元红包=1.5元人民币：通过第6即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    k.10000元红包=2元人民币：通过第9关即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    l.10000元红包=100元人民币：通过第20关且达成称号8后且点亮全部成就即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    m.10000元红包=1000元人民币：通过第35关且达成称号9后且点亮全部成就即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    n.10000元红包=10000元人民币：通过第50关且达成称号10后且点亮全部成就即可提现；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    通关天天领红包:
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    1)100元：通过第3关可每日领取1次；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    2)50000元：通过第20关且升至6级称号且点亮全部成就即可每日领取1次；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （7）【年末福利金】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    年末红包福利金金额88000元 :完成3步收款验证且需集齐点亮全部成就即可到账微信：
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （8）【成就】提现规则：点亮全部成就即可提取18000元现金 
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （9）【称号】提现规则：余额满10000元且点亮全部成就即可提现
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （10）产品内活跃等级共有 30 级，观看一定次数的视频广告即可升级，无其他要求，等级与对应的观看次数对应关系如下（前为观看次数，后为对应等级数，等级间以逗号分割）： "0":1 级，"2":2 级，"3":3 级，"4":4 级，"5":5 级，"6":6 级，"7":7 级，"8":8 级，"9":9 级，"10":10 级，"15":11 级，"20":12 级，"25":13 级，"30":14 级，"40":15 级，"50":16 级，"60":17 级，"70":18 级，"80":19 级，"100":20 级，"120":21 级，"140":22 级，"160":23 级，"180":24 级，"200":25 级，"300":26 级，"500":27 级，"800":28 级，"1000":29 级，"300000":30 级 。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （11）由于微信支付需要实名制，非实名用户账号无法支持提现，请务必将提现的微信号进行实名认证，因未实名导致的提现失败不进行退款；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    单笔提现金额最低 0.1 元。每日最多 10 次提现，除下述提及的档位提现要求以外，无注册时长条件，无在线时长条件，无提现间隔条件，无等级条件要求，无邀请好友，总体提现次数不限。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    上述“任务”类型或者“档位”类型的提现项，最大单笔金额为最高任务或者最大档位对应显示的金额，每个任务或者档位达到提示的要求即可提现，无其他要求，不同用户花费的时长也不一样。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    不同用户的广告收益不同，广告结束后会根据用户的广告价值计算和发放，不同用户达到对应档位的余额，时间也不一致。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    福运天地保留对本产品的最终解释权，若发现用户有外挂等恶意作弊行为，一律封禁账号并扣除账户所有余额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    
    </span>
</p>`;
